import { SearchBar } from '@/components/Common';
import LessonsFilters from './LessonsFilters';
import LessonsList from './LessonsList';
import { AddNewTopic, TopicsList } from '@/components/Views';
import { useLessons } from './lessons.hook';
import { FadeLoader } from 'react-spinners';
import LessonForm from './LessonForm';
import { Header } from '@/components/Layout/Header/Header';
import LessonDeletionModal from './LessonDeletionModal';
import { useDisciplineStore } from '@/store/DisciplineStore/DisciplineStore';
import { useTopicsStore } from '@/store/TopicStore/TopicsStore';

const Lessons = () => {
  const { loadingData, formMode, disciplines } = useLessons();
  const { setSelectedDiscipline, selectedDiscipline } = useDisciplineStore();
  const { isOpenTopicModal, openTopicModal } = useTopicsStore();
  return (
    <>
      <LessonForm mode={formMode} />
      <LessonDeletionModal />
      <AddNewTopic />
      {loadingData ? (
        <div className="w-full h-[100vh] flex items-center justify-center">
          <FadeLoader color="#FEC200" />
        </div>
      ) : (
        <div className="flex flex-col max-h-screen">
          <Header userName="Mas Aly" role="Admin" title="Gestion des leçons" />
          <div className="grid grid-cols-[25%_auto] items-start">
            <div className="pt-5 flex flex-col gap-10 h-[calc(100vh_-_110px)] overflow-hidden">
              <SearchBar placeholder="Rechercher une matière" />
              <TopicsList
                showBtn={true}
                items={disciplines}
                onItemClick={(item) => setSelectedDiscipline(item)}
                selectedItemId={selectedDiscipline?._id}
                onAddClick={() => openTopicModal()}
              />
            </div>
            <div className="flex flex-col gap-2 pl-10 pr-4 pt-3 h-[calc(100vh_-_110px)] overflow-hidden">
              <LessonsFilters />
              <LessonsList />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Lessons;
